'use strict';
(function($){
    /*
     * Vetology.Wizard widget
     *
     * @description Manages a Wizard using the children elements of the hosting element
     *
     * @options	See description for each option
     *
     * @method	See description above each method
     */
    $.widget(
        'Vetology.SignUpWizard',
        {
            options: {
                steps: ['selecting-type'],
                google_reachability: false,
                autocomplete: null,
                place_id: '',
                type: '',
                country_code: '1'
            },
            /*
             * Vetology.SignUpWizard
             *
             * @description Vetology.SignUpWizard._create constructor
             *
             * @return NULL
             *
             */
            _create: function(){
                var o = this;
            },
            /*
             * Vetology.SignUpWizard._init
             *
             * @description	Initializes the Vetology.SignUpWizard
             *
             * @return NULL
             *
             */
            _init: function(){
                var o = this;
                o._loadEvents();
                o._adjustSizeTypeSelectors();
                o._getAllCountries();
                var google_api_url = 'https://maps.googleapis.com//maps/api/js';
                $("body").Ajax("checkReachabilityUrl", google_api_url, o._pingCallBack.bind(o));
            },


            /**
             * Clear Manual form
             * @private
             */
            _clearManualForm: function(){
                $("#name").val('');
                $("#phone").val('');
                $("#email").val('');
                $("#address").val('');
            },
            /**
             * Sets and shows the manual form fields, with the place values obtained by google maps api
             * @param place
             */
            goForwardManualForm: function(place){
                var o = this;
                var country_code = null;
                o._clearManualForm();
                /** foreach for get Country code **/
                for(var i=0; i<place.address_components.length; i++){
                    if(place.address_components[i] !== null && place.address_components[i].types[0] === "country"){
                        country_code= place.address_components[i].short_name;
                        break;
                    }
                }
                /** complete values in form manual **/
                $('#name').val(place.name);
                $('#address').val(place.formatted_address);
                $('#country-selector').val(country_code).trigger('change');
                var countryData = $('#country-selector').select2('data')[0];
                if (countryData !== null && place !== null){
                    o.options.place_id = place.place_id;
                    o.options.country_code = countryData.country_code;
                    o._setPhoneCountry(countryData);
                }
                o._goForward('manual-form-wrapper');
            },

            /** set intenational number of country **/
            _setPhoneCountry: function(data){
                var o = this;
                var phone_mask = '';
                for(var i = 1; i <= parseInt(data.size_nsn_country); i++){
                    phone_mask += '9';
                }
                phone_mask = "'mask': '" + phone_mask +"'";

                $(".office-phone").attr("data-inputmask", phone_mask);
                $(".office-phone").inputmask();
                $(".office-phone").val('');
                $(".country-code-indicator").html("(+" + data.country_code + ")");
                o.options.size_nsn_country = parseInt(data.size_nsn_country);
            },
            /*
             * Vetology.SignUpWizard._loadEvents
             *
             * @description	Initializes the Vetology._loadEvents
             *
             * @return NULL
             *
             */
            _loadEvents : function(){
                var o = this;

                $(".auto_find_by_name").keyup(o._delay(function (e) {
                    if($('.pac-container').children().length == 0)
                        $(".manual-form-advice").show();
                    else $(".manual-form-advice").hide();
                }, 500));
                $("body").on("click", ".manual-form-link", function(e){
                    o._clearManualForm();
                    o._goForward("manual-form-wrapper");
                });
                $("body").on("click", ".viewSignup", function(e){

                    o._cleanSelectPlaceStep();

                    var type = $(this).data('block');

                    if(type === "consultantBlock")o.options.type = "consultant";
                    else if(type === "specialtyHospitalBlock")o.options.type = "specialty hospital";
                    else o.options.type = "clinic";

                    $(".wizard-step").find(".place-holder-type").html(o.options.type);

                    //Google api is available
                    if(o.options.google_reachability) {
                        o._goForward('searching-place');
                    }
                    else{
                        o._goForward('manual-form-wrapper');
                    }
                });
                $("body").on("click", ".go-back", function(e){
                    o._goBack();
                });
                $("body").on("submit", ".manual-form", function(e){
                    e.preventDefault();
                    var sign_up_form = this;

                    //Frontend validations
                    if(o.options.google_reachability && o.options.place_id === ''){
                        $(sign_up_form).find('.address-field').addClass('has-error');
                        $(sign_up_form).find('.address-field').find('.help-block').html('Please insert the address of your facility');
                        return;
                    }
                    var data = {};
                    data.name = $("#name").val();
                    data.iso = $("#country-selector").val();
                    data.country_code = o.options.country_code;
                    data.phone = o._validatePhoneNumber($("#phone").val());
                    data.email = $("#email").val();
                    data.type = o.options.type;
                    if(o.options.size_nsn_country !== data.phone.length){
                        $(sign_up_form).find('.phone-field').addClass('has-error');
                        $(sign_up_form).find('.phone-field').find('.help-block').html('Please check the phone number, it must contain ' + o.options.size_nsn_country + ' digits for the selected area code.');
                        return;
                    }




                    if(o.options.google_reachability){
                        data.place_id = o.options.place_id;
                        data.address = $("#address").val();
                    }
                    else{
                        data.addressObject = {
                            buildingNumber: $("#buildingnumber").val(),
                            street: $("#street").val(),
                            route: $("#route").val(),
                            city: $("#city").val(),
                            state: $("#state").val(),
                            zip: $("#zip").val()
                        }
                    }
                    $("body").Vetology("vetologyLoadStart");

                    loadEventsCallServer(data, sign_up_form);
                });

                $("#country-selector").on('select2:select',  function(e){
                    var data = e.params.data;
                    o.options.country_code = data.country_code;
                    o._setPhoneCountry(data);
                    if(o.options.google_reachability){
                        o.options.autocomplete.setComponentRestrictions({'country': [data.id]});
                        o.options.place_id = '';
                        $("#address").val('');
                    }
                });

	            $(".test-email-btn").on('click', function (e) {
	            	e.preventDefault();
	            	e.stopPropagation();
		            const $btn = $(e.currentTarget);
		            const email = $btn.hasClass('user-email') ? $('input[name=email]').val() : $('input[name=clinic_email]').val();
		            const clinicName = $('input.name').val();
					const firstName = $('input[name=name]').val();
					const lastName = $('input[name=last]').val();

		            const data = {
		            	email: email,
			            clinicName: clinicName,
			            firstName: firstName,
			            lastName: lastName,
			            type: $btn.hasClass('user-email') ? 'user' : 'clinic'
		            };

		            $.ajax({
						url: '/api/signup/send-test-email',
			            type: 'post',
			            data: data,
			            dataType: 'JSON'
		            }).done(function(data, textStatus, jqXHR) {
		            	if (data.success) {
				            $('body').Vetology("vetologyShowDialog", "Success", data.message, "success");
			            } else {
				            $('body').Vetology("vetologyShowDialog", "Error", data.message, "error");
			            }
		            }).fail(function(jqXHR, textStatus, errorThrown) {
			            $('body').Vetology("vetologyShowDialog", "Error", jqXHR.responseText, "error");

		            });
	            });
            },

            loadEventsCallServer: function (data, sign_up_form) {
                const o = this;
                $.ajax({
                    url: '/api/signup',
                    type: 'post',
                    data: data,
                    success: function (response) {
                        $(sign_up_form).find('.send-manual-form').blur();
                        $("body").Vetology("vetologyLoadEnd");

                        var results = response.results;
                        o.options.place_id = '';

                        if (typeof results !== 'undefined') {
                            o._goForward("success-manual-signup");
                        }
                    },
                    error: function (response) {
                        $("body").Vetology("vetologyLoadEnd");

                        var errors = response.responseJSON.errors;
                        if (errors.name) {
                            $(sign_up_form).find('.name-field').addClass('has-error');
                            $(sign_up_form).find('.name-field').find('.help-block').html(errors.name[0]);
                        }
                        if (errors.address) {
                            $(sign_up_form).find('.address-field').addClass('has-error');
                            $(sign_up_form).find('.address-field').find('.help-block').html(errors.address[0]);
                        }
                        if (errors.phone) {
                            $(sign_up_form).find('.phone-field').addClass('has-error');
                            $(sign_up_form).find('.phone-field').find('.help-block').html(errors.phone[0]);
                        }
                        if (errors.email) {
                            $(sign_up_form).find('.email-field').addClass('has-error');
                            $(sign_up_form).find('.email-field').find('.help-block').html(errors.email[0]);
                        }
                        if (errors['addressObject.buildingNumber']) {
                            $(sign_up_form).find('.address-components-field').addClass('has-error');
                            $(sign_up_form).find('.address-components-field').find('.help-block').html(errors['addressObject.buildingNumber'][0]);
                        }
                        if (errors['addressObject.city']) {
                            $(sign_up_form).find('.address-components-field').addClass('has-error');
                            $(sign_up_form).find('.address-components-field').find('.help-block').append("<br>" + errors['addressObject.city'][0]);
                        }
                        if (errors['addressObject.route']) {
                            $(sign_up_form).find('.address-components-field').addClass('has-error');
                            $(sign_up_form).find('.address-components-field').find('.help-block').append("<br>" + errors['addressObject.route'][0]);
                        }
                        if (errors['addressObject.state']) {
                            $(sign_up_form).find('.address-components-field').addClass('has-error');
                            $(sign_up_form).find('.address-components-field').find('.help-block').append("<br>" + errors['addressObject.state'][0]);
                        }
                        if (errors['addressObject.street']) {
                            $(sign_up_form).find('.address-components-field').addClass('has-error');
                            $(sign_up_form).find('.address-components-field').find('.help-block').append("<br>" + errors['addressObject.street'][0]);
                        }
                        if (errors['addressObject.zip']) {
                            $(sign_up_form).find('.address-components-field').addClass('has-error');
                            $(sign_up_form).find('.address-components-field').find('.help-block').append("<br>" + errors['addressObject.zip'][0]);
                        }
                        if (errors['general']) {
                            $('body').Vetology("vetologyShowDialog", "Unavailable", errors['general'][0], "info");
                        }
                    }
                });
            },

            _validatePhoneNumber: function (phoneNumber) {
                var newPhoneNumber = '';
                for (var i=0; i< phoneNumber.length; i++) {
                    if(phoneNumber.charAt(i) !== '_'){
                        newPhoneNumber = newPhoneNumber + phoneNumber.charAt(i);
                    }
                }
                return newPhoneNumber;
            },

            /*

             */
            _getAllCountries: function(){
                var o = this;
                var data = [];
                $.ajax({
                    url: '/countries',
                    type: 'GET',
                    data: {
                        fields: ['name_en', 'country_code', 'iso', 'size_nsn']
                    },
                    success: function(response){
                        $.each(response.results, function(key, country){
                            data.push({id: country.iso, text: country.name_en, country_code: country.country_code, size_nsn_country: country.size_nsn});
                        });
                        $("#country-selector").select2(
                            {
                                data: data,
                                width: '100%'
                            });
                        $("#country-selector").val("US").change();
                        var countryData = $('#country-selector').select2('data')[0];
                        o._setPhoneCountry(countryData);
                    },
                    error: function(){
                        console.error("Error");
                    }
                });

            },

            _cleanSelectPlaceStep: function(){
                $(".consultantSignUpForm").addClass("hide");
                $(".clinicSignUpForm").addClass("hide");
                $(".specialtyHospitalSignUpForm").addClass("hide");
                $(".mapBlock").removeClass("col-md-6");
            },


            /*
             * Vetology.SignUpWizard._adjustSizeTypeSelectors
             *
             * @description	Adjust the height of the types boxes
             *
             * @return NULL
             *
             */
            _adjustSizeTypeSelectors: function(){

                var heights = [];

                $(".viewSignup .small-box .inner").each(function(){
                    heights.push($(this).height());
                });
                $(".viewSignup .small-box .inner").each(function(){
                    $(this).css("height", Math.max.apply(Math, heights));
                });

            },

            /*
             * Vetology.SignUpWizard._delay
             *
             * @description	Generates a delay for a event
             *
             * @return NULL
             *
             */
            _delay : function (callback, ms) {
                var timer = 0;
                return function() {
                    var context = this, args = arguments;
                    clearTimeout(timer);
                    timer = setTimeout(function () {
                        callback.apply(context, args);
                    }, ms || 0);
                };
            },
            /*
             * Vetology.SignUpWizard._goBack
             *
             * @description	Goes back in the wizard
             *
             * @return NULL
             *
             */
            _goBack: function(){
                var o = this;
                if(o.options.steps.length > 1){
                    var stepOut = o.options.steps.pop();
                    var stepIn = o.options.steps[o.options.steps.length -1];
                    o._showStepWizard(stepOut, stepIn, "back");
                }
            },
            /*
             * Vetology.SignUpWizard._goForward
             *
             * @description	Goes forward in the wizard
             *
             * @return NULL
             *
             */
            _goForward: function(step){
                var o = this;

                var stepOut = o.options.steps[o.options.steps.length -1];
                var stepIn = step;
                o.options.steps.push(step);
                o._showStepWizard(stepOut, stepIn, "forward");
            },
            /*
             * Vetology.SignUpWizard._showStepWizard
             *
             * @description	Shows the passed element
             *
             * @return NULL
             *
             */
            _showStepWizard: function(stepOut, stepIn, directionWizard){
                var hideDirection = "left";
                var showDirection = "right";

                if(directionWizard === "back"){
                    hideDirection = "right";
                    showDirection = "left"
                }

                $("." + stepOut).hide("drop",
                    {
                        direction: hideDirection,
                        complete: function(){
                            $("." + stepIn).show("drop",
                                {
                                    direction: showDirection,
                                },
                                500
                            );
                        }
                    },
                    500
                );
            },
            /*
             * Vetology.SignUpWizard._pingCallBack
             * @description Callback to check if the google maps api is available and / or loaded to the application
             * @param response
             * @private
             */
            _pingCallBack: function(response){
                var o = this;
                if(response === "responded"){
                    o.options.google_reachability = true;

                    $(".address-components-field input").attr("disabled", true);

                    //TODO Change the timeout with another way to get google_reachability
                    setTimeout(function(){
                        if(typeof google === 'object' && typeof google.maps === 'object'){
                            o.options.autocomplete = new google.maps.places.Autocomplete($("#address")[0], ['address']);
                            o.options.autocomplete.setComponentRestrictions({'country': 'US'});
                            o.options.autocomplete.addListener("place_changed", function(){
                                var place = o.options.autocomplete.getPlace();
                                o.options.place_id = place.place_id;
                            });
                        }
                    }, 500);

                }
                else{
                    $(".address-field").hide();
                    $(".address-field input").attr("disabled", true);
                    $(".address-components-field").show();
                }
            }
        }
    );
})(jQuery);

